import { CascaderField, Col } from '@/components';
import { useProjectsSearchFormProviderState } from '@/features/search/_components/projects/_common/ProjectsSearchAccordionProvider';
import {
  COL_MIN_WIDTH,
  type SharedSearchFormKeys,
  type SharedSearchFormType,
  handleCascaderOnChange,
} from '@/features/search/_utils/projects-search';
import { useOrganizationOptionsRecursive } from '@/features/tenant-manager/hooks';
import { useMessage } from '@/providers';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const NestedOrganizationIdsColField: FC = memo(() => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const { type } = useProjectsSearchFormProviderState();

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<SharedSearchFormType>();

  const fiscalYear =
    type !== 'analysis' ? useWatch({ control, name: 'fiscalYear' }) : undefined;
  const organizationsOptions = useOrganizationOptionsRecursive({
    params: { referenceFiscalYear: fiscalYear?.year()?.toString() },
  });

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <CascaderField
        name={'nestedOrganizationIds' satisfies SharedSearchFormKeys}
        label={t('organization-in-charge')}
        control={control}
        options={organizationsOptions.data}
        loading={organizationsOptions.isLoading}
        multiple
        errors={errors}
        // hint={
        //   isPS()
        //     ? t('hint-organization-in-charge-cascader-selection', {
        //         limit: PS_MAX_CASCADER_SELECTION,
        //       })
        //     : t('hint-search-organization-in-charge')
        // }
        onChange={(value) => {
          handleCascaderOnChange(
            'nestedOrganizationIds' satisfies SharedSearchFormKeys,
            value,
            setValue,
            openMessage,
          );
        }}
      />
    </Col>
  );
});
